/**
 * Composant qui intègre le RestrictionBanner dans l'application
 * 
 * Ce composant affiche une bannière d'alerte si l'utilisateur connecté
 * a des restrictions actives ou est banni.
 */

import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { useRestrictionBanner } from '../../hooks/useRestrictions';
import RestrictionBanner from './RestrictionBanner';
import ActivitySuspensionBanner from './ActivitySuspensionBanner';

const RestrictionBannerWrapper = () => {
  const { isAuthenticated } = useAuth();

  // Ne pas afficher si non connecté
  if (!isAuthenticated) {
    return null;
  }
  
  return (
    <>
      <ActivitySuspensionBanner />
      <RestrictionBannerContent />
    </>
  );
};

/**
 * Contenu du banner (séparé pour éviter le hook quand non authentifié)
 */
const RestrictionBannerContent = () => {
  const {
    loading,
    shouldShow,
    isBanned,
    banType,
    banReason,
    banExpiresAt,
    restrictions
  } = useRestrictionBanner();

  // Ne pas afficher pendant le chargement ou si rien à afficher
  if (loading || !shouldShow) {
    return null;
  }
  
  return (
    <RestrictionBanner
      isBanned={isBanned}
      banType={banType}
      banReason={banReason}
      banExpiresAt={banExpiresAt}
      restrictions={restrictions}
    />
  );
};

export default RestrictionBannerWrapper;
